import { render, staticRenderFns } from "./ProviderDefaultSettings.vue?vue&type=template&id=6b411bd6&scoped=true&"
import script from "./ProviderDefaultSettings.vue?vue&type=script&lang=js&"
export * from "./ProviderDefaultSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b411bd6",
  null
  
)

export default component.exports